import { render, staticRenderFns } from "./OlabStrainSVGGen.vue?vue&type=template&id=6565cad8&"
import script from "./OlabStrainSVGGen.vue?vue&type=script&lang=js&"
export * from "./OlabStrainSVGGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports